import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { IApplicationState } from 'components/store/types'
import { getRegionCliniques } from 'components/core/state/selectors'
import { IClinique } from 'components/core/types'
import Slider from 'components/ui/abstract/Slider'
import CliniqueCard from 'components/ui/CliniqueCard'

const mapState = (state: IApplicationState) => ({
  cliniques: getRegionCliniques(state),
})
const connector = connect(mapState)

const CliniquesSliderContainer = ({ cliniques }: ConnectedProps<typeof connector>) => (
  <Slider cliniques={cliniques}>
    {cliniques.map((clinique: IClinique) => (<CliniqueCard key={clinique.id} clinique={clinique} />))}
  </Slider>
)
export default connector(CliniquesSliderContainer)
